import React, { useContext, useState, useEffect, useRef } from 'react'
import { ReactComponent as FiltersIcon } from '../../../assets/media/icons/filter-funnel.svg'
import styles from './Filters.module.scss'
import PropTypes from 'prop-types'
import ApplicationContext from '../../../context/ApplicationContext'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { useSearchLocation } from '../../../hooks'

const Filters = ({ toggleFiltersList, appliedFilters }) => {
    const [applicationData] = useContext(ApplicationContext)
    const [localizations] = useState(applicationData.localizations)
    const { handleUnitChange, unitTypeOptions, unitTypeValue, hideSort } = useSearchLocation()
    const [announcement, setAnnouncement] = useState('')
    const previousUnitRef = useRef(unitTypeValue)

    useEffect(() => {
        // Announce unit change to screen readers
        if (previousUnitRef.current !== unitTypeValue && previousUnitRef.current !== undefined) {
            setAnnouncement(`Distance unit changed to ${unitTypeValue}`)
            // Clear announcement after a short delay
            setTimeout(() => setAnnouncement(''), 1000)
        }
        previousUnitRef.current = unitTypeValue
    }, [unitTypeValue])

    const unitTypeMilesHandler = () => {
        handleUnitChange(unitTypeOptions.filter(option => option.title === localizations.miles)[0])
    }

    const unitTypeKilometersHandler = () => {
        handleUnitChange(unitTypeOptions.filter(option => option.title === localizations.kilometers)[0])
    }

    return (
        <div className={styles.filtersBar}>
            {/* Screen reader announcement for unit changes */}
            <div
                role="status"
                aria-live="polite"
                aria-atomic="true"
                className={styles.srOnly}
            >
                {announcement}
            </div>
            <ToggleSwitch
                leftText={localizations.miles}
                leftHandler={unitTypeMilesHandler}
                rightHandler={unitTypeKilometersHandler}
                rightText={localizations.kilometers}
                controller={unitTypeValue === unitTypeOptions.filter(option => option.title === localizations.miles)[0].title}
            />
            <div className={styles.openModal}>
                <button type='button' className={styles.openModal_button} onClick={toggleFiltersList}>
                    <FiltersIcon />
                    <span>
                        {localizations.filter}
                        {appliedFilters?.length > 0 && ` (${appliedFilters?.length})`}
                        {!hideSort && ` / ${localizations.sort}`}
                    </span>
                </button>
            </div>
        </div>
    )
}

Filters.propTypes = {
    toggleFiltersList: PropTypes.func,
    appliedFilters: PropTypes.array,
    onClear: PropTypes.func,
}

export default Filters
